import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PathLocationStrategy, LocationStrategy, CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { AppConfigState } from './store/app-config/app-config.state';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';

// import mockServer from './mock-data/app.mock';
import { LoginComponent } from './views/auth/login/login.component';
import { LogoModule } from './shared/components/logo/logo.module';
import { AuthService } from './services/auth.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';
import { InquiryDataComponent } from './views/inquiry-data/inquiry-data.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CheckboxModule } from './shared/components/checkbox/checkbox.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CapitalizePipe } from './shared/pipes/capitalize.pipe';
import { RegisterComponent } from './views/auth/register/register.component';
import { NewUserComponent } from './views/new-user/new-user.component';
import { UploadModule } from './shared/components/upload/upload.module';
import { RadioModule } from './shared/components/radio/radio.module';
import { AddProjectComponent } from './views/add-project/add-project.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ProjectsComponent } from './views/projects/projects.component';
import { DropdownModule } from './shared/components/dropdown/dropdown.module';
import { RemovePrefixPipe } from './shared/pipes/remove-prefix.pipe';
import { UpdateDetailComponent } from './views/update-detail/update-detail.component';
import { DetailsListComponent } from './views/details-list/details-list.component';
import { ToastrModule } from 'ngx-toastr';
import { ImportDataComponent } from './views/import-data/import-data.component';
import { SwitchModule } from './shared/components/switch/switch.module';

// mockServer();

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        RegisterComponent,
        InquiryDataComponent,
        CapitalizePipe,
        NewUserComponent,
        AddProjectComponent,
        ProjectsComponent,
        RemovePrefixPipe,
        UpdateDetailComponent,
        DetailsListComponent,
        ImportDataComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        LogoModule,
        TranslateModule.forRoot(),
        LayoutModule,
        NgxDatatableModule,
        NgxsModule.forRoot([
            AppConfigState
        ]),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxsLoggerPluginModule.forRoot(),
        HttpClientModule,
        NgSelectModule,
        CheckboxModule,
        DropdownModule,
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        UploadModule.forRoot(),
        RadioModule,
        SwitchModule,
        BsDatepickerModule.forRoot(),
        ToastrModule.forRoot(),
    ],
    providers: [AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
